import { FiltersState } from "@/redux/myClub/myPlayersSlice";

import { tradeable as tradeableIcon } from "../../../../icons";
import Button from "../../SolutionCustomizer/Buttons/Button";
import GenerateSidebar from "../GenerateSidebar";
import { Filter } from "./Filters.type";

type FiltersProp = {
  onFilterClicked: (filter: Filter) => void;
  closeFilters: () => void;
  filters: FiltersState;
};

const FiltersSidebar = ({
  onFilterClicked,
  filters,
  closeFilters,
}: FiltersProp) => (
  <GenerateSidebar onClickedOutside={closeFilters}>
    <div className="flex flex-col mx-auto mb-auto text-white gap-y-2">
      <div className="pb-4 mx-auto text-base">Filters</div>
      <div className="mx-auto w-[140px] h-[60px]">
        <Button
          title={"Special"}
          active={filters.special}
          square={false}
          onClick={() => onFilterClicked("special")}
          customSize={true}
        >
          <img
            alt="Special"
            className="w-6"
            src={`${
              import.meta.env.VITE_APP_ASSETS_BASE_URL
            }/fut23/cards/e_3_3.png?scale=50.png`}
          />
        </Button>
      </div>
      <div className="mx-auto w-[140px] h-[60px]">
        <Button
          title={"Gold"}
          active={filters.gold}
          square={false}
          onClick={() => onFilterClicked("gold")}
          customSize={true}
        >
          <img
            alt="Gold"
            className="w-6"
            src={`${
              import.meta.env.VITE_APP_ASSETS_BASE_URL
            }/fut23/cards/e_1_3.png?scale=50.png`}
          />
        </Button>
      </div>
      <div className="mx-auto w-[140px] h-[60px]">
        <Button
          title={"Silver"}
          active={filters.silver}
          square={false}
          onClick={() => onFilterClicked("silver")}
          customSize={true}
        >
          <img
            alt="Silver"
            className="w-6"
            src={`${
              import.meta.env.VITE_APP_ASSETS_BASE_URL
            }/fut23/cards/e_1_2.png?scale=50.png`}
          />
        </Button>
      </div>
      <div className="mx-auto w-[140px] h-[60px]">
        <Button
          title={"Bronze"}
          active={filters.bronze}
          square={false}
          onClick={() => onFilterClicked("bronze")}
          customSize={true}
        >
          <img
            alt="Bronze"
            className="w-6"
            src={`${
              import.meta.env.VITE_APP_ASSETS_BASE_URL
            }/fut23/cards/e_1_1.png?scale=50.png`}
          />
        </Button>
      </div>
      <div className="mx-auto w-[140px] h-[60px] mt-4">
        <Button
          title={"SBC Storage"}
          active={filters.sbcStorage}
          square={false}
          customSize={true}
          onClick={() => onFilterClicked("sbcStorage")}
        >
          <img
            src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/sbc-icons/sbc-storage.png`}
            alt="sbc storage"
          />
        </Button>
      </div>
      <div className="mx-auto w-[140px] h-[60px]">
        <Button
          title={"Transfer List"}
          active={filters.transferList}
          square={false}
          customSize={true}
          onClick={() => onFilterClicked("transferList")}
        >
          <img
            src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/sbc-icons/transfer-list.png`}
            alt="transfer list"
          />
        </Button>
      </div>
      <div className="mx-auto w-[140px] h-[60px]">
        <Button
          title={"Duplicates"}
          active={filters.duplicates}
          square={false}
          customSize={true}
          onClick={() => onFilterClicked("duplicates")}
        >
          <img
            src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/sbc-icons/duplicate.png`}
            alt="duplicate"
          />
        </Button>
      </div>
      <div className="mx-auto w-[140px] h-[60px]">
        <Button
          title={"Untradeables"}
          active={filters.untradeables}
          square={false}
          customSize={true}
          onClick={() => onFilterClicked("untradeables")}
        >
          <img
            src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/sbc-icons/untradeable.png`}
            alt="untradeable"
          />
        </Button>
      </div>
      <div className="mx-auto w-[140px] h-[60px]">
        <Button
          title={"Tradeables"}
          active={filters.tradeables}
          square={false}
          customSize={true}
          onClick={() => onFilterClicked("tradeables")}
        >
          {tradeableIcon}
        </Button>
      </div>
      <div className="mx-auto w-[140px] h-[60px] mt-4">
        <Button
          title={"Manually Added"}
          active={filters.manuallyAdded}
          square={false}
          customSize={true}
          onClick={() => onFilterClicked("manuallyAdded")}
        >
          <img
            src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/sbc-icons/manually-added.png`}
            alt="manually added"
          />
        </Button>
      </div>
    </div>
  </GenerateSidebar>
);

export default FiltersSidebar;
